import React, { useState, useEffect } from 'react';
import { ScrollView, View, StyleSheet, Text } from 'react-native';
import { useNavigation, useRoute } from '@react-navigation/native';
import { useAuth } from '../config/AuthContext';
import config from '../config/config';

export function AlarmeScreen({ route }) {
  const { deviceName } = route.params;
  const tableName = 'equipstates';
  const { maquinaId } = useAuth();
  const [alarmes, setAlarmes] = useState([]);
  const navigation = useNavigation();
  const mensagensDesejadas = [
    'Salvar Dados no PC',
    'Máquina Parada',
    'Falha Comunicação com Sensor',
    'Sensor de Presença Acionado',
    'Comprimento Fora do Padrão',
    'Falha de Medição',
    'Alarme 7',
    'Alarme 8',
    'Alarme 9',
    'Alarme 10',
  ];

  useEffect(() => {
    fetchData();
    const interval = setInterval(fetchData, 5000);
    return () => clearInterval(interval);
  }, []);

  async function fetchData() {
    try {
      const tabelaEndpoint = `${config.apiBaseUrl}/tables/${tableName}?$filter=maquinaId eq '${maquinaId}'`;
      const response = await fetch(tabelaEndpoint, {
        headers: {
          'ZUMO-API-VERSION': '2.0.0',
        },
      });

      const data = await response.json();
      const parsedData = JSON.parse(data[0].dados);

      const alarmesFiltrados = parsedData
        .filter((item) => item.Nome === deviceName)
        .flatMap((item) =>
          item.Alarmes.filter((alarme) =>
            mensagensDesejadas.includes(alarme.Mensagem),
          ),
        )
        .map((alarme) => ({
          Mensagem: alarme.Mensagem,
          NotifEnabled: alarme.NotifEnabled,
          Ativo: alarme.Ativo,
          DthUltimo: alarme.DthUltimo,
        }));

      setAlarmes(alarmesFiltrados);
    } catch (error) {
      console.log(`Erro ao listar dados: ${error.message}`);
    }
  }

  useEffect(() => {
    if (alarmes.length > 0) {
      const numAtivos = alarmes.filter((alarme) => alarme.Ativo).length;
      navigation.navigate('DeviceScreen', { numAtivos: numAtivos });
    }
  }, [alarmes]);

  function getAlarmStyle(ativo) {
    return {
      backgroundColor: ativo ? 'red' : '#CCCCCA',
    };
  }

  return (
    <ScrollView contentContainerStyle={styles.scrollContainer}>
      {alarmes.map((alarme, index) => (
        <View
          key={index}
          style={[
            styles.border,
            styles.containerAlarms,
            getAlarmStyle(alarme.Ativo),
          ]}
        >
          <Text style={styles.descrition}>{alarme.Mensagem}</Text>
          <Text style={styles.dateTime}>{alarme.DthUltimo}</Text>
        </View>
      ))}
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollContainer: {
    flexGrow: 1,
    paddingVertical: 10,
    backgroundColor: '#CCCCCA',
  },
  border: {
    borderBottomWidth: 1,
    borderColor: '#A8A8A8',
  },
  containerAlarms: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: 10,
    paddingHorizontal: 15,
  },
  descrition: {
    fontSize: 12,
  },
  dateTime: {
    fontSize: 10,
    color: '#666563',
  },
});
